<template>
  <div v-if="loading " />
  <div v-else-if="fields">
    <v-dialog v-model="dialog" scrollable max-width="300px">
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
          @click.stop.prevent="dialog=true"
          outlined
          :color="Color"
          style="margin-bottom: 20px;"
        >
          {{$t('common.sigin')}}
        </v-btn>
      </template>
      <v-card :color="BGColor">
        <v-btn
          text
          x-small
          absolute
          top
          right
          :color="Color"
          @click="dialog = false"
          style="margin-right: -15px !important;margin-top: 0px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <center><v-icon style="margin-top: 30px;font-size:90px !important;" :style="{ 'color': Color}">mdi-account-circle</v-icon></center>
        <center style="margin-top:10px;margin-bottom:20px;">
          <h3 style="font-weight:400;" :style="{ 'color': Color}">{{$t('customAuth.guestAccess').toUpperCase()}}</h3>
        </center>
        <v-layout 
          wrap
          :color="BGColor"
          :style="{ backgroundColor: BGColor }"
        >
          <v-flex 
            xs12
            v-for="item of fields"
            :key="item.key"
          >
            <center>
              <h4 :style="{ 'color': Color}">{{$t(`noray.fields.${item.key}`, locale)}} *</h4>
            </center>
            <v-text-field
              v-if="item.type === 'string'"
              v-model="editedItem[item.key]"
              solo
              style="margin: 5px 10px 0;"
              :color="Color"
              hide-details
            />
            <auth-date
              v-else-if="item.type === 'date'"
              :k="item.key"
              :isLight="isLight"
              :color="BGColor"
              :onChange="handleChangeDate"
            />
              <div style="padding: 0 10px;min-height:10px">
                <v-alert 
                  v-if="required.indexOf(item.key) >= 0" 
                         dense 
                         outlined 
                         color="red"
                  style="margin-top:5px;"
                >
                  {{$t(`noray.messages.required`, locale)}}
                </v-alert>
              </div>
          </v-flex>
          <v-flex xs12>              
          <v-alert v-if="message" dense outlined color="red">
            {{message}}
          </v-alert>
          <v-layout wrap style="padding: 5px">            
            <v-btn :color="Color" outlined="" block @click.stop.prevent="handleSigin">{{$t('common.sigin', locale)}}</v-btn>
          </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
  <div v-else-if="authType !== 'none' && authData">
    <v-row justify="center">
      <v-btn
        text
        :color="Color"
        @click.stop="dialogLogout = true"
      >
        
        {{authData.Guest}}
      </v-btn>
      <v-dialog
        v-model="dialogLogout"
        max-width="290"
      >
        <v-card>          
          <v-card-title :style="{ 'color': btnTextColor}">{{ $t('dashboard.logout') }}</v-card-title>
          <v-card-text :style="{ 'color': btnTextColor}">{{ $t('customAuth.logoutMsg') }}</v-card-text>

          <!-- <v-card-text>
            Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
          </v-card-text> -->

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialogLogout = false"
            >
              {{$t('common.cancel')}}
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="handleLogout"
            >
              {{$t('dashboard.logout')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import tinycolor from 'tinycolor2'
import apiDtouch from '@/services/apiDtouch'
import axios from 'axios'
import utils from '@/services/utils'
import constants from '@/constants'
import AuthDate from './AuthDate'
export default {
  components: {
    AuthDate,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    fields: null,
    editedItem: {},
    required: [],
    modal: false,
    dialogLogout: false,
    dialog: false,
    bookingCode: '',//'OCU13579',
    date: new Date().toISOString().split('T')[0],//'2020-06-10',
    room: '',
    surname: '',
    message: null      
  }),

//     Reserva:
// Bono: 13579 Fecha Llegada:20/06/2020

// Ocupación (Ckeckin):
// Bono: OCU13579 Fecha Llegada: 10/06/2020

// Cancelación:
// Bono CAN13579 Fecha Llegada: 05/08/2020

// Tentativa:
// Bono: TEN13579 Fecha llegada: 01/08/2020

// Salida:
//                 Bono: 123 Fecha llegada:13/08/2017
  computed: {
    ...mapState('app',['locale', 'authData', 'btnBackgroundColor', 'btnTextColor', 'Color', 'BGColor', 'FontContent', 'FontSizeContent', 'ColorContent']),
    isDev () {
      return process.env.VUE_APP_ENV === 'development'
    },
    authType () {
      return this.$store.state.app.authType
    },
    isSimulation () {
      return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
    },
    enterpriseID () {
      return this.$store.state.app.enterpriseID
    },
    isLight () {
      return tinycolor(this.BGColor).isLight()
    }
  },
  mounted () {
    this.handleGetConfig()
    if (this.isDev) {
      this.room = 102
      this.surname = 'Doe'
    }
    this.handleCheckSigin()
    // if (this.$session.get('norayIdentifier') && this.$session.get('norayIdentifier').length > 0) this.handleSigin()
  },
  methods: {
    handleGetConfig () {
      this.loading = true
      apiDtouch.getAll(`v1/public/workspaces/${this.workspaceID}/noray`)
        .then(response => {
          this.fields = response
          this.loading = false
        })
        .catch(error => {
          console.log('error', error)
          this.loading = false
        })
    },
    handleLogout () {
      this.$store.state.app.authData = null
      this.$session.set('norayResponse', null)
      this.$session.set('charResponse', null)
      this.dialogLogout = false
    },
    handleCheckSigin () {    
      const data = this.$session.get('norayResponse')
      if (data && data.Identifier.length > 0) {
        const body = {
          Identifier: data.Identifier,
          bookingCode: data.bookingCode
        }
        axios.post(utils.getAPIURL('utils/noray', false, this.isSimulation ? this.enterpriseID : null), body)
        .then(response => {
          if (response.data.CheckinStatus === "1") {
            // si sigue en el hotel mostramos los datos
            this.$store.state.app.authData = data
          } else {
            // si no sigue cerramos session
            this.$store.state.app.authData = null
            this.$session.set('norayResponse', null)
          }
          this.loading = false
        })
        .catch(error => {
          console.log('error', error)
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    handleChangeDate (key, v) {
      this.editedItem[key] = v
    },
    handleCheckFields () {
      let result = true
      this.required = []
      for (let item of this.fields) {
        if (!this.editedItem[item.key] || this.editedItem[item.key].length === 0) {
          this.required.push(item.key)
          result = false
        }
      }
      return result
    },
    handleSigin () {
      if (!this.handleCheckFields()) return
      console.log(this.editedItem)
      apiDtouch.addItem(`v1/public/workspaces/${this.workspaceID}/noray`, this.editedItem)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log('error', error)
        })
      return
      const body = {}
      body.bookingCode = this.bookingCode
      body.entranceDate = this.date
      axios.post(utils.getAPIURL('utils/noray', false, this.isSimulation ? this.enterpriseID : null), body)
      .then(response => {
        switch (response.data.BookingStatus) {
          case '0':
            this.message = this.$t('customAuth.noray.noCheckin')
            break;
          case '1':
            const data = response.data && response.data.BookingDetails  ? response.data.BookingDetails : null
            data.bookingCode = body.bookingCode
            this.$session.set('norayResponse', data)
            this.$store.state.app.authData = data
            this.message = null
            break
          case '2':
            this.message = this.$t('customAuth.noray.exit')
            break
          case '3':
            this.message = this.$t('customAuth.noray.noBookin')
            break
          default:
            this.message = this.$t('customAuth.noray.error')
            break;
        }
      })
      .catch(error => {
        console.log('error', error)
      })       
    }
  }
}
</script>
